var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from 'syf-component-library/defaultTheme';
import { StyledAlert, StyledMessageBox } from './subcomponents';
var Alert = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'warning' : _b, title = _a.title;
    // TODO: add remaining alert types (success, info, error...)
    var alertTypes = {
        warning: {
            icon: faExclamationCircle,
            color: colors.warning
        }
    };
    var alertType = alertTypes[type];
    return (_jsx(StyledAlert, { children: _jsx(StyledMessageBox, __assign({ type: "warning", icon: _jsx(FontAwesomeIcon, { icon: alertType.icon, size: "lg" }) }, { children: title })) }));
};
export default Alert;
//# sourceMappingURL=index.js.map